export default __webpack_public_path__ + "static/media/adult_data.43be6b34.csv";